import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { ComposerReleaseField } from './ComposerReleaseField';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ComposerReleasePanelProps {
  items?: CatalogItem[];
  value?: string;
  onChange: (uuid: string | undefined) => void;
}

/**
 * The second step of the Composer: the release of the post. It comes before the copy, because
 * "Write with AI" writes from it (owner request 2026-10-09).
 */
const ComposerReleasePanelComponent: React.FC<ComposerReleasePanelProps> = ({ items, value, onChange }) => {
  const intl = useIntl();

  return (
    <Panel data-testid="composer-release-panel">
      <div className={styles.copyBody}>
        <ComposerReleaseField items={items} value={value} onChange={onChange} />
        <p className={styles.aiHint}>
          {intl.formatMessage({
            id: 'app.sml.promote.composer.release.hint',
            defaultMessage: 'The AI writes the copy from the release. The post links to its SmartLink.',
          })}
        </p>
      </div>
    </Panel>
  );
};

export const ComposerReleasePanel = TypedMemo(ComposerReleasePanelComponent);
